var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncorrectIc16X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3358 1.36776C2.85051 0.876761 2.06369 0.876761 1.5784 1.36776C1.09311 1.85876 1.09311 2.65483 1.5784 3.14584L6.26975 7.89237L1.36397 12.8559C0.878677 13.3469 0.878677 14.1429 1.36397 14.6339C1.84926 15.1249 2.63608 15.1249 3.12137 14.6339L8.02715 9.67045L12.9102 14.6109C13.3955 15.1019 14.1823 15.1019 14.6676 14.6109C15.1529 14.1199 15.1529 13.3238 14.6676 12.8328L9.78455 7.89237L14.4531 3.16887C14.9384 2.67787 14.9384 1.8818 14.4531 1.3908C13.9678 0.899796 13.181 0.899796 12.6957 1.3908L8.02715 6.1143L3.3358 1.36776Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectIc16X16);
export default __webpack_public_path__ + "static/media/incorrect_ic_16x16.3f9fd80e1a030f647c598fe4e579a25f.svg";
export { ForwardRef as ReactComponent };